// `env` injected via webpack. Will break portal however, since this file is imported without the context of webpack. Thus, `try-catch`
let environment;
try {
  environment = env
} catch (e) {
  environment = { PRODUCTION: true }
};

export const MMS_ORIGIN = environment.PRODUCTION
  ? 'https://cdn.privacy-mgmt.com/mms/v2'
  : 'https://mms.sp-stage.net/mms/v2';

export const CCPA_ORIGIN = environment.PRODUCTION
  ? 'https://ccpa-service.sp-prod.net'
  : 'https://ccpa.sp-stage.net';

export const CMPV2_ORIGIN = environment.PRODUCTION
  ? 'https://cdn.privacy-mgmt.com/consent/tcfv2'
  : 'https://cmpv2.sp-stage.net/tcfv2';

export const ccpaRoutes = {
  DELETE: 'delete-my-data',
  DSAR: 'dsar',
};

export const sarViews = {
  FORM: 'form',
  SUCCESS: 'success',
  error: {
    VERIFICATION: 'verification',
    MAX_REQUESTS: 'max-requests',
    ACTIVE_REQUEST: 'active-request'
  },
};

export const dsarRetrievalViews = {
  HOME: 'home',
  ONE_TIME_CODE: 'one-time-code',
  CODE_SUCCESS: 'code-success',
  REQUEST_PENDING: 'request-pending',
};

export const privacyManagerOTTViews = {
  HOME: 'home',
  CATEGORIES: 'categories',
  VENDORS: 'vendors',
  CARD_DETAILS: 'card_details',
  PRIVACY_POLICY: 'privacy_policy',
  CUSTOM_VIEW: 'custom_view'
};

export const VERIFICATION_FAILURE = 'VERIFICATION_FAILURE';
export const MAX_REQUESTS_EXCEEDED = 'MAX_REQUESTS_EXCEEDED';
export const MISMATCH = 'MFA_CODE_FAILURE';
export const PROCESSING_REQUEST = 'PROCESSING_REQUEST';

export const lockedVendors = [];

export const inputNames = {
  FIRST_NAME: 'first-name',
  LAST_NAME: 'last-name',
  EMAIL: 'email',
  PHONE: 'phone',
  SSN: 'ssn',
  REQUEST_ID: 'request-id',
  MFA: 'mfa',
};

let isIE;
try {
  (document.createElement('input')).type = 'date';
  isIE = false;
} catch (e) {
  isIE = true;
};

export { isIE }

export const actionTypes = {
  SAVE_AND_EXIT: 1,
  REJECT_ALL: 13,
  ACCEPT_ALL: 11,
  CANCEL: 2,
};